/* eslint-disable @typescript-eslint/no-explicit-any */

import { AfterViewInit, Component, ElementRef, HostListener, Inject, OnInit, PLATFORM_ID, Renderer2, ViewChild} from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from '../../services/auth.service';
import { CartService } from '../../services/cart.service';
import { AppService } from '../../api.service';
import { DepartmentsService } from '../../services/departments.service';
import { LocationService } from '../../services/location.service'
import { PopupService } from '../../services/popup.service';
import { ProjectsService } from '../../services/project.service';
import { AddToCartService } from '../../services/add-to-cart.service';
import { HomeService } from 'src/app/home.service';
import { WindowService } from '../../services/window.service';
import { TrialService } from 'src/app/services/trial.service';
import { Meta, Title } from '@angular/platform-browser';
import { Location, isPlatformBrowser, ViewportScroller } from '@angular/common';
import { CashbackService } from '../../services/cashback.service';
import { AbInfoPopupService } from '../../services/ab-info-popup.service';
import { LocalStorageService } from '../../services/localstorage.service';
import { SearchService } from '../../services/search.service';
import { MessageService } from 'primeng/api';

declare let ReconnectingWebSocket: any;
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  providers: [MessageService]
})
export class HeaderComponent implements OnInit, AfterViewInit {
  @ViewChild('scrollableDiv') scrollableDiv!: ElementRef;
  global_loader = false;
  isProfileSilder = false;
  is_pageup_button = false;
  topmenuId: any;
  activeCategory: undefined;
  activeCategory_obj: any;
  project_id: any;
  activemcId: undefined;
  activemcIndex: undefined;
  activesctId: undefined;
  activescIndex: undefined;
  selectedValue: any = '';
  filteredCountries: any;
  filterCountry: any;
  isdepartmentLoaders = true;
  isHideLoginPage = false;
  activeFlow: any;
  isOnMobilePlatform = false;
  lattitude = 28.6139391;
  longitude = 77.20902120000005;
  user_location!: { latitude: number; longitude: number; address: any; locality: any; city: any; pincode: any; };
  isShake!: boolean;
  userId: any;
  notification: any[] = [];
  shownotification!: boolean;
  noticount!: number;
  results: any;
  result!: string;
  isSearchActive!: boolean;
  loggedInUsername!: any;
  selectedBrand: any;
  isDepartment!: boolean;
  activeBrandIndex!: number;
  is_locations_error!: boolean;
  isBrowser=false;
  // query!:string;
  sug_sub_categories: any[]=[];
  sug_product_types: any[]=[];
  sug_brands:any[]=[];
  isSuggetionPopUp!: boolean;
  sug_products: any[]=[];
  is_top_search_shadow!:boolean;
  showLeftButton = false;
  showRightButton = true;
 
  constructor(@Inject(PLATFORM_ID) private platformId: any, private window: WindowService, public _ds: DepartmentsService, public _as: AppService, public router: Router, public _ar: ActivatedRoute,private localStorageService: LocalStorageService,public _ss:SearchService,
    private auth: AuthService, public _cart: CartService, public locationService: LocationService, private toastr: ToastrService,public title: Title,public meta:Meta,public _cs:CashbackService,public _abpopupinfo:AbInfoPopupService, private ViewportScroller: ViewportScroller,
    public _pop: PopupService, public _project: ProjectsService, public _addToCartService: AddToCartService, private renderer: Renderer2, public _hs: HomeService, public _trial: TrialService,public _location:Location,private messageService: MessageService) {
      if(isPlatformBrowser(platformId)){
    this.isOnMobilePlatform = this._as.isOnMobilePlatform;
    
  }
  }
  ngOnInit(): void {
    // this._pop.showWarning('Too Many Requests', 'Try again in 1 minute.');
    this.isBrowser = isPlatformBrowser(this.platformId);
    this._ar.queryParams.subscribe((pra: any) => {
      if(this._as.isUserLoggedIn){
        this._trial.isTrialExpire = pra.isTrialExpire
      }
      if (pra.isdisplybrandpopup) {
        setTimeout(() => {
          this._hs.isdisplybrandpopup = pra.isdisplybrandpopup;
        }, 1000);
      }
    });
    
    if(isPlatformBrowser(this.platformId)){  
  
    if (this.isOnMobilePlatform) {
      this.getLoggedInUsername();
      this.getSubacriptionTimeout()
    }

    if (this._as.isLoginPage) {
      this.isHideLoginPage = true;
    }

    if (this._as.isUserLoggedIn) {
      this.getNotificationCount();
      this.notificationConnection();
      this._project.checkCart();
      this._cart.getSampleCartStatus();
    }
    this._ds.getAllDepartments();
    this._ds.getAllSampleDCP();


  }
  }

optimizeImageUrl(url: string): { imgUrl: string; srcset?: string; lqipUrl?: string } {
    if (!url || !url.includes("/upload/")) {
      return { imgUrl: url };
    }
    // For small icons, we don't need srcset or LQIP since they're tiny and load quickly
    const imgUrl = url.replace("/upload/", "/upload/f_auto,q_auto,w_64/");
    return { imgUrl };
  }
  @HostListener('document:scroll', ['$event'])
 onWindowScroll() {
    if(window.pageYOffset > 150){
      this.is_top_search_shadow = true;
    }else{
      this.is_top_search_shadow = false;
    }
  }
  getSubacriptionTimeout() {
    try {
      const socket = new ReconnectingWebSocket(this._as.ws_path);
      this.userId = JSON.parse(this.localStorageService.getItem('user_info') || "").userProfile.user_id;
      const data_to_be_send = { 'action': 'notification', 'user': this.userId };
      setTimeout(() => {
        socket.send(JSON.stringify(data_to_be_send));
      }, 2000);
      socket.onclose(() => {
        const socket = new ReconnectingWebSocket(this._as.ws_path);
        socket.send(JSON.stringify(data_to_be_send));
      });
      socket.onerror(() => {
        const socket = new ReconnectingWebSocket(this._as.ws_path);
        socket.send(JSON.stringify(data_to_be_send));
      });
      socket.onmessage = (message: any) => {
        this.noticount = JSON.parse(message.data).total_notification;
        try {
          const user_info = JSON.parse(this.localStorageService.getItem('user_info') || "");
          this._as.user_info.noticount = JSON.parse(message.data).total_notification;
          user_info.noticount = JSON.parse(message.data).total_notification;
          this.localStorageService.setItem('user_info', JSON.stringify(user_info));
        } catch {
        // eslint-disable-next-line no-empty
        }
      };
    } catch {
   // eslint-disable-next-line no-empty
    }
  }
  getLoggedInUsername() {
    if (this._as.user_info?.userProfile.username && !this._as.user_info?.userProfile.last_name) {
      this.loggedInUsername = this._as.user_info?.userProfile.username[0]
    }
    else if (this._as.user_info?.userProfile.username && this._as.user_info?.userProfile.last_name) {
      this.loggedInUsername = this._as.user_info?.userProfile.username[0] + this._as.user_info?.userProfile.last_name[0];
    }
    else {
      this.loggedInUsername = undefined;
    }
  }
  setSeoData(){
    this.meta.updateTag({property: 'og:title', content:'Explore Interior finishing & fitting products from trending Brands | afterbricks.com'});
    this.meta.updateTag({property: 'og:image', content: this._as.site_url+'/assets/images/home/b1.webp'});
    this.meta.updateTag({property: 'og:url', content:  this._as.site_url+'/'})
    this.meta.updateTag({name: 'description', content:  "Afterbricks helps professionals like interior designers, architects & contractors to explore & research latest interior finishing & fitting products from trending & creditable brands for their projects & also enable them collaborate within the connected ecosystem."})
  }

  ngAfterViewInit() {
    this.renderer.listen('document', 'click', (event: MouseEvent) => {
      const target = event.target as HTMLElement;
      if (target.id === 'check' || target.id === 'mcheck' || target.id === 'noti') {
        const token = this.localStorageService.getItem('user_info') || "";
        if (token === undefined) {
          this.router.navigate(['']);
        }
        this.shownotification = !this.shownotification;
      } else {
        this.shownotification = false;
      }
    });

  }
  openBrandPopup() {
    this._project.getLiveOffers();
    this.instantshow();
  }
  
  getShowStatus() {
    const pageURL = this.router.url.split('/')[1].split('?')[0];
    if (pageURL == 'house-spaces') {
      return false
    } else {
      return true
    }
  }
  
  getProjectStatus() {
    if (this.router.url.split('/')[1] == "budget-calc") {
      return false
    } else {
      return true
    }
  }
  joinaspro() {
    const returnUrl = this._as.subscribeUrl + '/home';
    const win = this.window.nativeWindow
    if (win){
      win.location.href = returnUrl;
    }
   
  }
  isShow(){
    const pageURL = this.router.url.split('/')[1].split('?')[0];
    if(!pageURL){
      return true
    }else{
      return false
    }
  }
  openProfileright() {
    this._as.visibleSideProfile = true;

  }
  closeProfileright() {
    this._as.visibleSideProfile = false;
  }
  goToHome() {
    this.router.navigate([''])
  }

  onMegaDepartmentHover(id: any) {
    this.topmenuId = id;
    this.activeCategory = undefined;
  }
  onSubCategoryTypeopen(category_obj: any) {
    this.activeCategory_obj = category_obj;
  }
  onSubCategory(scid: any, scindex: any) {
    if (this.activesctId == scid) {
      this.activesctId = undefined;
      this.activescIndex = undefined;
      return
    }
    this.activesctId = scid;
    this.activescIndex = scindex
  }
  onScrollEnlable(cat: any) {
    document.body.style.overflowY = "scroll"; // ADD THIS LINE
    this.topmenuId = undefined;
    const uri = '/department/' + cat
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
      this.router.navigate([uri]));
  }
  onCategoryLink(d_slug_name: any, sub_cat: any) {
    this.topmenuId = undefined;
    document.body.style.overflowY = "scroll";
    const uri = 'd/' + d_slug_name + '/' + sub_cat
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
      this.router.navigate([uri]));
    this.isSuggetionPopUp = false;
  }

  onCategoryTypeLink(slug_name: string, sub_cat: any, product_type: any, cat_Id?: any) {
    this.topmenuId = undefined;
    document.body.style.overflowY = "scroll";
    const uri = '/product/' + slug_name
    const queryParams: Params = { pId: this.project_id, subCat: sub_cat, category: cat_Id }
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
      this.router.navigate([uri], { queryParams: queryParams }));
    this.Enavelscroll()
    this.clearData()
  }

  Enavelscroll() {
    document.body.style.overflowY = "scroll";
    this.topmenuId = undefined;
  }
  onMainCategory(mcid: any, mcindex: any) {
    if (this.activemcId == mcid) {
      this.activemcId = undefined;
      this.activemcIndex = undefined;
      this.activesctId = undefined;
      this.activescIndex = undefined;
      return
    }
    this.activemcId = mcid;
    this.activemcIndex = mcindex
  }

  backMainCategory() {
    this.activemcId = undefined;
    this.activemcIndex = undefined;
  }
  backSubCategory() {
    this.activesctId = undefined;
    this.activescIndex = undefined;
  }
  clearData() {
    this.activemcId = undefined;
    this.activemcIndex = undefined;
    this.activesctId = undefined;
    this.activescIndex = undefined;
    this._as.displayNavSlider = false;
  }
  onMegaMenuMobile() {
    this._as.displayNavSlider = true;
  }

  logoutUser() {
    this.auth.onLogout();
    this.isProfileSilder = false;
    this.instantshow();
  }
  hideSlider() {
    this.global_loader = true;
    setTimeout(() => {
      this.isProfileSilder = false;
    }, 100);
    setTimeout(() => {
      this.global_loader = false;
    }, 10);
  }

  onCart() {
    this._ar.queryParams.subscribe((pra: any) => {
      this.activeFlow = pra.fl
    })
    let project_id: any;
    try {
      project_id = this._project.getProjectId();
    } catch {
      // eslint-disable-next-line no-empty
    }
    if (this._project.cart_data?.cart_product_count) {
      this.router.navigate(['my-list'], { queryParams: { fl: this.activeFlow, pId: project_id, is_brandsPopup: true } });
    }
    else {
      this.router.navigate(['my-list']);
    }
    this.instantshow();
  }
  onNewCart() {
    this._ar.queryParams.subscribe((pra: any) => {
      this.activeFlow = pra.fl
    })
    let project_id: any;
    try {
      project_id = this._project.getProjectId();
    } catch {
      // eslint-disable-next-line no-empty
    }
    if (this._project.cart_data?.cart_product_count) {
      this.router.navigate(['cart'], { queryParams: { fl: this.activeFlow, pId: project_id, is_brandsPopup: true } });
    }
    else {
      this.router.navigate(['cart']);
    }
    this.instantshow();
  }
  onSampleOrders(){
    this.router.navigate(['sample-order']);
    this.instantshow();
  }
  onProject() {
    this.router.navigate(['ab-project']);
    this.instantshow()
  }

  onSaveIdea() {
    this._ar.queryParams.subscribe((pra: any) => {
      this.activeFlow = pra.fl
    })
    let project_id: any;
    try {

      project_id = this._project.getProjectId();

    } catch {
      // eslint-disable-next-line no-empty
    }

    const page_name_url = this.router.url.split('/')[1]
    if (page_name_url == 'product') {
      const slug_name = this.router.url.split('/')[2].split('?')[0]
      this.router.navigate(['saved-ideas/' + slug_name], { queryParams: { fl: this.activeFlow, pId: project_id, is_department: true } })
    } else {
      this.router.navigate(['saved-ideas/' + this._as.cart_data.saveidea_slug_name], { queryParams: { fl: this.activeFlow, pId: project_id, is_department: true } })
    }
    this.instantshow()
  }

  instantshow() {
    this.global_loader = true;
    setTimeout(() => {
      this._as.visibleSideProfile = false;
    }, 100);
    setTimeout(() => {
      this.global_loader = false;
    }, 10);
  }

  profile() {
    this._as.visibleSideProfile = false;
    this._as.displayNavSlider = false;
    this.router.navigate(['/profile']);
    this.instantshow()
  }
  // ----------------- Locations ------------------ //
  
 

  onShake() {
    if(this.router.url.split('/')[1]=='cart'){
      this.isShake = true;
      setTimeout(() => {
        this.isShake = false;
      }, 2000);
    
    }else{
      this._as.locationPop = false;
    }
  }
  isCloseIcon(){
    if(this.router.url.split('/')[1]=='cart'){
     return false
    
    }
    return true
  }
  // ----------------- End Locations --------------//
  goToProfile() {
    this.isProfileSilder = false;
    this.router.navigate(['/profile']);
    this.instantshow()
  }
  goToOrderPage() {
    if (!this.project_id) {
      this.project_id = this._project.getProjectId();
    }
    this.router.navigate(['my-order'], { queryParams: { fl: 'search', pId: this.project_id, } })
    this.instantshow();
  }
  //-----------------Notifications----------------------------//

  notificationConnection() {
    try {

      const socket = new ReconnectingWebSocket(this._as.ws_path);
      this.userId = JSON.parse(this.localStorageService.getItem('user_info') || "").userProfile.user_id;
      const data_to_be_send = { 'action': 'notification', 'user': this.userId };
      setTimeout(() => {
        socket.send(JSON.stringify(data_to_be_send));
      }, 2000);
      socket.onclose(() => {
        const socket = new ReconnectingWebSocket(this._as.ws_path);
        socket.send(JSON.stringify(data_to_be_send));
      });
      socket.onerror(() => {
        const socket = new ReconnectingWebSocket(this._as.ws_path);
        socket.send(JSON.stringify(data_to_be_send));
      });
      socket.onmessage = (message: any) => {
        const data = JSON.parse(message.data);
        this.noticount = data.total_notification;
        try {
          const user_info = JSON.parse(this.localStorageService.getItem('user_info') || "");
          this._as.user_info.noticount = JSON.parse(message.data).total_notification;
          user_info.noticount = JSON.parse(message.data).total_notification;
          this.localStorageService.setItem('user_info', JSON.stringify(user_info));
          if(data.is_trial && data.is_trial_expire){
            this._trial.updateLocalStorage(data);
          }
        } catch {
         // eslint-disable-next-line no-empty
        }
      };
    } catch {
    // eslint-disable-next-line no-empty
    }
  }
  getNotificationCount() {
    const url = this._as.api_base_url + "user/notifictionsCount/";
    this._as.getRequest(url, true).subscribe(
      (res: any) => {
        this.noticount = res.count;
        this._as.user_info.noticount = res.count;
        const user_info = JSON.parse(this.localStorageService.getItem("user_info") || '');
        this._as.user_info.noticount = res.count;
        user_info.noticount = res.count;
        this.localStorageService.setItem("user_info", JSON.stringify(user_info));
      });
  }

  onNotification() {
    this.userId = JSON.parse(this.localStorageService.getItem('user_info') || "").userProfile.user_id;
    const page = 1;
    const url = this._as.api_base_url + `user/notification/?form_type=form_type&page=${page}`;

    this._as.getRequest(url, true)
      .subscribe((res: any) => {
        this.notification = res.data;
        this.shownotification = true;
        for (const info of this.notification) {
          info.notification.offer_price = new Intl.NumberFormat('en-IN', { maximumSignificantDigits: 6 }).format(info.notification.offer_price)
        }
      });
  }
  redirect(link: any, id: any, notification: any) {
    const url = this._as.api_base_url + `user/readNotification/?id=` + id;
    this._as.getRequest(url, true)
      .subscribe((res: any) => {
        if(res){
          this.shownotification = false;
          if (this._as.user_info.noticount) {
            this._as.user_info.noticount = this._as.user_info.noticount - 1;
          }
          
          let queryParams!: Params;
          if (notification.noti_type == 'cartage_replace') {
            queryParams = { pId: notification.project_id, brandId: notification.brand_id, slug_name: notification.slug_name }
          }
          this.redirectTo(link, queryParams);
        }
      });
  }
  redirectTo(uri: string, queryParams: any) {
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
      this.router.navigate([uri], { queryParams: queryParams }));
  }
  getMoreNotifications() {
    this._ar.queryParams.subscribe((pra: any) => {
      this.project_id = pra.pId;
    });
    this.router.navigate(['/notifications'], { queryParams: { pId: this.project_id } });
  }
  //--------------------END Notifications-----------------------------------//

  onProduct() {
    this._hs.isdisplybrandpopup = true;
    this.isProfileSilder = false;
  }

 
  newGlobleSearch(q:any){
    
    const url = this._as.api_base_url + 'search/search-suggestions/?q=' + q + '&form';
    this._as.getRequest(url, true)
      .subscribe((res: any) => {
        this.sug_sub_categories = res.sub_categories;
        this.sug_product_types = res.product_types;
        this.sug_brands = res.brands;
        this.sug_products = res.products;
        // this.results = res.results;
      },(err:any)=>{
        console.log("Error in search suggestion",err)
        this.sug_sub_categories = [];
        this.sug_product_types = [];  
        this.sug_brands = [];
        this.sug_products = [];
        this.messageService.add({ severity: 'error', summary: 'Server busy', detail: 'Unable to process search request. Please try again shortly.' });
      });
  }
  getSuggetionStatus(){
    if( this.sug_sub_categories?.length || this.sug_product_types?.length || this.sug_brands?.length || this.sug_products.length){
      return true
    }else{
      return false
    }
  }
  getBrandHeding(items:any){
    if(items.length > 1){
      return 'Brands'
    }else{
      return 'Brand'
    }
  }
  getProductTypeHeading(items:any){

    if(items.length > 1){

      return 'Product types'
    }else{
      return 'Product type'
    }
  }
  getcategoryHeading(items:any){
    if(items.length > 1){
      return 'Categorys'
    }else{
      return 'Category'
    }
  }

  focusSuggetionpup(){
      this.isSuggetionPopUp = true;
      if(this._as.isOnMobilePlatform){
      if (isPlatformBrowser(this.platformId)) {
        const mainOptionsContainer = document.getElementById('globle-search-mob');
        if (mainOptionsContainer) {
          const offsetTop = this.getOffsetTop(mainOptionsContainer) - 0;
          this.ViewportScroller.scrollToPosition([0, offsetTop]);
        }
      }
      }
  }
  private getOffsetTop(element: HTMLElement): number {
    let offsetTop = element.offsetTop;
    let offsetParent = element.offsetParent as HTMLElement;
    while (offsetParent) {
      offsetTop += offsetParent.offsetTop;
      offsetParent = offsetParent.offsetParent as HTMLElement;
    }
    return offsetTop;
  }
  focusOutSuggetionpup(){
    setTimeout(() => {
      this.isSuggetionPopUp = false;
    }, 500);
  }
  
  onSearchSmartview(){
    this.isSuggetionPopUp = false;
    this.router.navigate(['./smart-search'],{queryParams:{q:this._ss.query.replace(' ', '-')}})
  }
  // onOptionProduct(event: any) {
  //   const red_obj = event;
  //   let queryParams: any;
  //   let url: any;
  //   if (this.selectSearchType.code == 'sku') {
  //     queryParams = { fl: this.activeFlow, pId: this.project_id }
  //     url = 'p/' + red_obj.product_slug

  //   } else {
  //     queryParams = { subCat: red_obj.sub_category_id, category: red_obj.category_type, fl: this.activeFlow, pId: this.project_id }
  //     url = 'product/' + red_obj.slug_name

  //   }
  //   this.redirectTo(url, queryParams)
  //   this.result = '';
  //   this.isSearchActive = false;
  // }
 hideSection(){
  if ( (this.router.url.split('/')[1]  == "sample-order") || (this.router.url.split('/')[1]  == "sample-checkout") || (this.router.url.split('/')[1]  == "checkout")) {
    return false
  } else {
    return true
  }
 }
  getStatus() {
    if (this.router.url.split('/')[1] == "" || this.router.url.split('/')[1] == "?isUrlc=true" || this.router.url.split('/')[1].split('?')[0] == "smart-search") {
      return false
    } else {
      return true
    }
  }
  getTabStatus(){
    if (this.router.url.split('/')[1] == "login" || this.router.url.split('/')[1] == "login?sf=otp" || this.router.url.split('/')[1] == "?isUrlc=true" || this.router.url.split('/')[1].split('?')[0]  == "smart-search" || (this.router.url.split('/')[1]  == "sample-order") || (this.router.url.split('/')[1]  == "sample-checkout") || (this.router.url.split('/')[1]  == "cart") || (this.router.url.split('/')[1]  == "checkout")) {
      return false
    } else {
      return true
    }
  }
  onSmartView(){
    if((this.router.url.split('/')[1].split('?')[0] == "smart-search") || (this.router.url.split('/')[1]  == "checkout")){
      return true
    }else{
      return false
    }
  }
  closeDeptPopUp() {
    this._hs.isdisplybrandpopup = false;
    this._project.displayProject = false;
  }
  goToDeptPage(mc: any) {
    const uri = '/department/' + mc.slug_name
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
      this.router.navigate([uri]));
    this.closeDeptPopUp();
  }
  goToProductPage(proj?: any) {
    this._project.selectedProject = proj;
    this.localStorageService.setItem('selectedProject', JSON.stringify(this._project.selectedProject));
    this._hs.isdisplybrandpopup = true;
  }
  goToCollection(proj?: any) {
    this._project.selectedProject = proj;
    this.localStorageService.setItem('selectedProject', JSON.stringify(this._project.selectedProject));
    this.router.navigate(['as-collection/'], { queryParams: { pId: proj.id, wId: proj.project_steps.slug_name } })
    this._project.displayProject = false;
  }

  onProceedPayment() {
    const nextUrl = this.router.url;
    this.router.navigate(
      [],
      {
        relativeTo: this._ar,
        queryParams: { isTrialExpire: null, },
        queryParamsHandling: 'merge'
      });
    this._trial.isTrialExpire = false;
    const subscribeLink = this._as.subscribeUrl + 'subscription' + '?token=' + this._as.user_info.token.access_token+'?nextUrl='+encodeURIComponent(nextUrl);
    window.location.href = subscribeLink;
  }

  onTypeLink(slug:string,subCatId:any,typeId:any){
    this.topmenuId=undefined;
    const uri = 'product/'+ slug
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
      this.router.navigate([uri],{queryParams:{subCat:subCatId,category:typeId}}));
    this.isSuggetionPopUp = false;
  }

  onBrandLink(slug:string){
    this.topmenuId=undefined;
    const uri = 'brand/'+ slug;
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
      this.router.navigate([uri]));
    this.isSuggetionPopUp = false;
  }
  safePathCheck(): string | null {
    if (!this._location || !this._location.path) {
      return null;
    }
    const pathSplit = this._location.path().split('/');
    if (pathSplit.length > 1) {
      const firstPart = pathSplit[1];
      return firstPart.split('?')[0];
    }
    return null;
  }
  onProductDetail(prod: any) {
    const red_obj = prod;
    // let queryParams: any;
    // let url: any;
    const queryParams = { fl: this.activeFlow, pId: this.project_id }
    const url = 'p/' + red_obj.slug

    this.redirectToString(url, queryParams)
    this.result = '';
    this.isSearchActive = false;
    this.isSuggetionPopUp = false;
  }
  redirectToString(uri: string, queryParams:any) {
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
      this.router.navigate([uri],{ queryParams: queryParams }));
  }


  scrollLeft(): void {
    const container = this.scrollableDiv.nativeElement;
    container.scrollBy({ left: -200, behavior: 'smooth' }); // Scroll left by 200px
    this.checkScroll();
  }

  scrollRight(): void {
    const container = this.scrollableDiv.nativeElement;
    container.scrollBy({ left: 200, behavior: 'smooth' }); // Scroll right by 200px
    this.checkScroll();
  }
  checkScroll(): void {
    const container = this.scrollableDiv.nativeElement;
    const maxScrollLeft = container.scrollWidth - container.clientWidth;

    this.showLeftButton = container.scrollLeft > 0;
    this.showRightButton = container.scrollLeft < maxScrollLeft;
  }

  openSampleCart(){
    this.router.navigate(['sample-checkout/list'])
  }
  showSampleBtn(){
   
    if(this._cart.sample_count){
     
      if((this.router.url.split('/')[1] == "sample-checkout")  || (this.router.url.split('/')[1] == "cart") || (this.router.url.split('/')[1] == "checkout") || (this.router.url.split('/')[1] == "my-order") || (this.router.url.split('/')[1] == "my-order")){
        
        return false
      }
      return true
    }
    return false
  }
}
